import React, { useEffect } from 'react';
import '../../styles/mainContents.css'
import MUIDataTable from 'mui-datatables';
import { connect } from 'react-redux';

function EmptyMuiDataTable(props) {

  const { title } = props;

  const options = {
    filterType: "checkbox",
    selectableRows: "none",
    Pagination: false,
    download:false,
    responsive: "standard",
    search: false,
    searchOpen: false, 
    print: false,
    filter: false,
    viewColumns: false 
  };

  return (
    <div>
        <div>           
          <div className='EmptyTable'>          
            { 
              <MUIDataTable
                title={title}
                data={undefined}
                columns={undefined}
                options={options}                 
              />             
            }
          </div>          
        </div>
    </div>
  );
}


const mapStateToProps = (state) => {
 return {
 }
};

const mapDispatchToProps = (dispatch) => {
  return {   
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EmptyMuiDataTable);